module.exports = __webpack_public_path__ + "img/washi unique.738b208f.png";